export const nav = [
  {
    text: 'home',
    path: '/',
  },
  {
    text: 'about',
    path: '/about',
  },
  {
    text: 'services',
    path: '/services',
  },
  {
    text: 'blog',
    path: '/blog',
  },
  {
    text: 'pricing',
    path: '/pricing',
  },
  {
    text: 'contact',
    path: '/contact',
  },
]
export const featured = [
  {
    cover: '../images/hero/h1.png',
    name: 'Family House',
    total: '122 Property',
  },
  {
    cover: '../images/hero/h2.png',
    name: 'House & Villa',
    total: '155 Property',
  },
  {
    cover: '../images/hero/h3.png',
    name: 'Apartment',
    total: '300 Property',
  },
  {
    cover: '../images/hero/h4.png',
    name: 'Office & Studio',
    total: '80 Property',
  },
  {
    cover: '../images/hero/h6.png',
    name: 'Villa & Condo',
    total: '80 Property',
  },
]
export const list = [
  {
    id: 1,
    cover: '../images/list/1.jpg',
    name: 'Red Carpet Real Estate',
    location: '210 Zirak Road, Canada',
    category: 'For Rent',
    price: '$3,700',
    type: 'Apartment',
  },
  {
    id: 2,
    cover: '../images/list/2.jpg',
    name: 'Fairmount Properties',
    location: '5698 Zirak Road, NewYork',
    category: 'For Sale',
    price: '$9,750',
    type: 'Condos',
  },
  {
    id: 3,
    cover: '../images/list/3jpg.jpg',
    name: 'The Real Estate Corner',
    location: '5624 Mooker Market, USA',
    category: 'For Rent',
    price: '$5,860',
    type: 'Offices',
  },
  {
    id: 4,
    cover: '../images/list/4.jpg',
    name: 'Herringbone Realty',
    location: '5621 Liverpool, London',
    category: 'For Sale',
    price: '$7,540',
    type: 'Homes & Villas',
  },
  {
    id: 5,
    cover: '../images/list/5.jpg',
    name: 'Brick Lane Realty',
    location: '210 Montreal Road, Canada',
    category: 'For Rent',
    price: '$4,850',
    type: 'Commercial',
  },
  {
    id: 6,
    cover: '../images/list/6.webp',
    name: 'Banyon Tree Realty',
    location: '210 Zirak Road, Canada',
    category: 'For Sale',
    price: '$2,742',
    type: 'Apartment',
  },
]
export const awards = [
  {
    icon: <i class='fa-solid fa-trophy'></i>,
    num: '2M	',
    name: 'Blue Burmin Award',
  },
  {
    icon: <i class='fa-solid fa-briefcase'></i>,
    num: '3 M',
    name: 'Mimo X11 Award',
  },
  {
    icon: <i class='fa-solid fa-lightbulb'></i>,
    num: '5 M',
    name: 'Australian UGC Award',
  },
  {
    icon: <i class='fa-solid fa-heart'></i>,
    num: '4 M',
    name: 'IITCA Green Award',
  },
]
export const location = [
  {
    id: 1,
    name: 'New Orleans, Louisiana',
    Villas: '12 Villas',
    Apartments: '10 Apartments',
    Offices: '07 Offices',
    cover: './images/location/1.jpg',
  },
  {
    id: 2,
    name: 'Jerrsy, United State',
    Villas: '12 Villas',
    Apartments: '10 Apartments',
    Offices: '07 Offices',
    cover: './images/location/2.jpg',
  },
  {
    id: 3,
    name: 'Liverpool, London',
    Villas: '12 Villas',
    Apartments: ' 10 Apartments',
    Offices: '07 Offices',
    cover: './images/location/3.jpg',
  },
  {
    id: 4,
    name: 'NewYork, United States',
    Villas: '12 Villas',
    Apartments: ' 10 Apartments',
    Offices: '07 Offices',
    cover: './images/location/4.jpg',
  },
  {
    id: 5,
    name: 'Montreal, Canada',
    Villas: '12 Villas',
    Apartments: ' 10 Apartments',
    Offices: '07 Offices',
    cover: './images/location/5.jpg',
  },
  {
    id: 6,
    name: 'California, USA',
    Villas: '12 Villas',
    Apartments: ' 10 Apartments',
    Offices: '07 Offices',
    cover: './images/location/6.jpg',
  },
]
export const team = [
  {
    list: '50',
    cover: '../images/customer/1.webp',
    address: 'Liverpool, Canada',
    name: 'Sargam S. Singh',
    icon: [
      <i class='fa-brands fa-facebook-f'></i>,
      <i class='fa-brands fa-linkedin'></i>,
      <i class='fa-brands fa-twitter'></i>,
      <i class='fa-brands fa-instagram'></i>,
    ],
  },
  {
    list: '70',
    cover: '../images/customer/2.jpg',
    address: 'Montreal, Canada',
    name: 'Harijeet M. Siller',
    icon: [
      <i class='fa-brands fa-facebook-f'></i>,
      <i class='fa-brands fa-linkedin'></i>,
      <i class='fa-brands fa-twitter'></i>,
      <i class='fa-brands fa-instagram'></i>,
    ],
  },
  {
    list: '80',
    cover: '../images/customer/3.jpg',
    address: 'Denever, USA',
    name: 'Anna K. Young',
    icon: [
      <i class='fa-brands fa-facebook-f'></i>,
      <i class='fa-brands fa-linkedin'></i>,
      <i class='fa-brands fa-twitter'></i>,
      <i class='fa-brands fa-instagram'></i>,
    ],
  },
  {
    list: '51',
    cover: '../images/customer/4.jpg',
    address: '2272 Briarwood Drive',
    name: 'Michael P. Grimaldo',
    icon: [
      <i class='fa-brands fa-facebook-f'></i>,
      <i class='fa-brands fa-linkedin'></i>,
      <i class='fa-brands fa-twitter'></i>,
      <i class='fa-brands fa-instagram'></i>,
    ],
  },
  {
    list: '42',
    cover: '../images/customer/5.jpg',
    address: '2272 Briarwood Drive',
    name: 'Michael P. Grimaldo',
    icon: [
      <i class='fa-brands fa-facebook-f'></i>,
      <i class='fa-brands fa-linkedin'></i>,
      <i class='fa-brands fa-twitter'></i>,
      <i class='fa-brands fa-instagram'></i>,
    ],
  },
  {
    list: '38',
    cover: '../images/customer/6.jpg',
    address: 'Montreal, USA',
    name: 'Adam K. Jollio',
    icon: [
      <i class='fa-brands fa-facebook-f'></i>,
      <i class='fa-brands fa-linkedin'></i>,
      <i class='fa-brands fa-twitter'></i>,
      <i class='fa-brands fa-instagram'></i>,
    ],
  },
]
export const price = [
  {
    plan: 'Basic',
    price: '29',
    ptext: 'per user, per month',
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '99.5% Uptime Guarantee',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '120GB CDN Bandwidth',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '5GB Cloud Storage',
      },
      {
        change: 'color',
        icon: <i class='fa-solid fa-x'></i>,
        text: 'Personal Help Support',
      },
      {
        change: 'color',
        icon: <i class='fa-solid fa-x'></i>,
        text: 'Enterprise SLA',
      },
    ],
  },
  {
    best: 'Best Value',
    plan: 'Standard',
    price: '49',
    ptext: 'per user, per month',
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '99.5% Uptime Guarantee',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '150GB CDN Bandwidth',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '10GB Cloud Storage',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: 'Personal Help Support',
      },
      {
        change: 'color',
        icon: <i class='fa-solid fa-x'></i>,
        text: 'Enterprise SLA',
      },
    ],
  },
  {
    plan: 'Platinum',
    price: '79',
    ptext: '2 user, per month',
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '100% Uptime Guarantee',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '200GB CDN Bandwidth',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: '20GB Cloud Storage',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: 'Personal Help Support',
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: 'Enterprise SLA',
      },
    ],
  },
]
export const footer = [
  {
    title: 'LAYOUTS',
    text: [
      { list: 'Home Page' },
      { list: 'About Page' },
      { list: 'Service Page' },
      { list: 'Property Page' },
      { list: 'Contact Page' },
    ],
  },
  {
    title: 'ALL SECTIONS',
    text: [{ list: 'Headers' }, { list: 'Features' }, { list: 'Footers' }],
  },
  {
    title: 'COMPANY',
    text: [{ list: 'About' }, { list: 'Blog' }, { list: 'Pricing' }],
  },
]
